'use client';
import { Error } from 'components/Error';
import { JSX } from 'react';
import { useClientContext } from '$/modules/context/client';
import { AppError, getErrorStatus } from '$/types/error';

export default function ErrorPage({
  error,
}: {
  error?: AppError;
}): JSX.Element {
  const errorStatus = getErrorStatus(error);
  return (
    <div className="col-span-full">
      <Error statusCode={errorStatus} locale={useClientContext().lang} />
    </div>
  );
}
